// Try to get the data from the cache
let cachedIngredientsData = localStorage.getItem("ingredientsData");
let ingredientsData;

if (cachedIngredientsData) {
  ingredientsData = JSON.parse(cachedIngredientsData);
}

window.addEventListener("DOMContentLoaded", async function () {
  function showIngredientInfo(data) {
    const titleTag = document.querySelector(".ingredient-title");
    const scoreTag = document.querySelector(".ingredient-score");
    const descriptionTag = document.querySelector(".ingredient-description");

    titleTag.textContent = data.name;
    scoreTag.textContent = `EWG Score: ${data.score}`;
    descriptionTag.textContent = data.description;

    if (data.id == "dime_proprietary_blend") {
      titleTag.dataset.bsTarget = "#fragrance-modal";
      titleTag.style.textDecoration = "underline";
    } else {
      titleTag.dataset.bsTarget = "";
      titleTag.style.textDecoration = "none";
    }
  }

  const $ingredientsBlock = document.getElementById("super-star-ingredients");

  if ($ingredientsBlock) {
    // If data wasn't cached, fetch it
    if (!ingredientsData) {
      const responseFromFirebase = await fetch(
        "https://us-central1-dime-app-8394d.cloudfunctions.net/api/ingredients"
      );
      ingredientsData = await responseFromFirebase.json();

      localStorage.setItem("ingredientsData", JSON.stringify(ingredientsData));
    }

    // Population data to desktop
    document.querySelectorAll("[data-ingredient-id]").forEach(($row, index) => {
      const ingredientData = ingredientsData[$row.dataset.ingredientId];

      if (ingredientData) {
        $row.textContent = ingredientData.name;
        $row.dataset.score = ingredientData.score;
        $row.dataset.description = ingredientData.description;

        if ($row.dataset.ingredientId == "dime_proprietary_blend") {
          $row.dataset.bsTarget = "#fragrance-modal";
        }
      }

      if (index == 0) {
        showIngredientInfo(ingredientData);
      }
    });

    // Population data to mobile
    document
      .querySelectorAll("[data-ingredient-mobile-id]")
      .forEach(($row, index) => {
        const ingredientData = ingredientsData[$row.dataset.ingredientMobileId];

        if (ingredientData) {
          $row.textContent = ingredientData.name;
          $row.dataset.score = ingredientData.score;
          $row.dataset.description = ingredientData.description;
        }

        if (index == 0) {
          const scoreTag = document.querySelector(".ingredient-score-mobile");
          const descriptionTag = document.querySelector(
            ".ingredient-description-mobile"
          );

          scoreTag.textContent = `EWG Score: ${ingredientData.score}`;
          descriptionTag.textContent = ingredientData.description;
        }
      });
  }

  // Populate desktop modal
  const items = document.querySelectorAll(".ingredients-text");

  items.forEach((item) => {
    item.onclick = function () {
      items.forEach((otherItem) => {
        otherItem.classList.remove("item-active");
      });

      item.classList.add("item-active");

      showIngredientInfo({
        id: item.dataset.ingredientId,
        name: this.textContent,
        score: this.dataset.score,
        description: this.dataset.description,
      });
    };
  });

  // Populate tabs modal
  const itemsMobile = document.querySelectorAll(".ingredients-text-mobile");

  itemsMobile.forEach((item) => {
    item.onclick = function () {
      itemsMobile.forEach((otherItem) => {
        otherItem.parentElement.classList.remove("active-accordion-header");
      });

      item.parentElement.classList.add("active-accordion-header");

      const parentDiv = this.parentElement.parentElement;
      const scoreTag = parentDiv.querySelector(".ingredient-score-mobile");
      const descriptionTag = parentDiv.querySelector(
        ".ingredient-description-mobile"
      );

      scoreTag.textContent = `EWG Score: ${this.dataset.score}`;
      descriptionTag.textContent = this.dataset.description;
    };
  });

  const fullIngredientsBtn = document.querySelector(".full-ingredients-btn");

  fullIngredientsBtn.addEventListener("click", async () => {
    const skuProduct = document.getElementById("cfm-sku").textContent;
    let ingredientTitle = document.querySelector("#modal-body-detail .title");
    const loading = document.querySelector(
      "#ingredients-modal #quick-view-load"
    );

    fetch(
      `https://clickable-api.clearforme.com/api/app/products/details/v2?clientname=dime%20beauty&sku=${skuProduct}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2MzBjYmZiZGJkZmJlOTAwMjFmOTU4MmMiLCJzdG9yZVVybCI6Imh0dHBzOi8vZGltZWJlYXV0eWNvLmNvbS9jb2xsZWN0aW9ucy8iLCJpYXQiOjE2ODQzNTE0MjB9.iCNSO-jE_h7hKuVSADV-l5zBFP6JlrbsdsDTDEsSmUg`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (loading)
          loading.remove();

        ingredientTitle.textContent = "Ingredients";

        if (data.productIngredients.length > 1) {
          ingredientTitle.textContent = "System Ingredients";
        }

        const existingContainers = document.querySelectorAll(
          ".ingredient-section"
        );

        if (existingContainers.length) {
          existingContainers.forEach((container) => container.remove());
        }

        data.productIngredients.forEach((product, index) => {
          const container = document.createElement("div");
          container.classList.add("ingredient-section");

          const componentTitle = document.createElement("p");
          componentTitle.classList.add(
            "component-title",
            "text-uppercase",
            "mb-5"
          );
          const ingredients = document.createElement("p");
          ingredients.classList.add("all-ingredients-container");

          const collapseContainer = document.createElement("div");
          collapseContainer.classList.add("collapse");
          collapseContainer.setAttribute("id", `product-${index}`);
          const collapseInfo = document.createElement("div");
          collapseInfo.classList.add("ingredient-details", "card", "card-body");

          collapseContainer.appendChild(collapseInfo);

          componentTitle.textContent = product.component;

          container.appendChild(componentTitle);
          container.appendChild(ingredients);
          container.appendChild(collapseContainer);

          const mainContainer = document.getElementById("modal-body-detail");
          mainContainer.appendChild(container);

          product.ingredientGroup[0].ingredients.forEach((ingredient, counter) => {
            const link = document.createElement("a");

            link.href = `#product-${index}`;
            link.setAttribute("data-bs-toggle", "collapse");
            link.setAttribute("href", `#product-${index}`);
            link.setAttribute("role", "button");
            link.setAttribute("aria-expanded", "false");
            link.setAttribute("aria-controls", `product-${index}`);

            link.textContent = `${ingredient.ingredientName}${(counter < product.ingredientGroup[0].ingredients.length - 1) ? ", " : ""}`;

            ingredients.appendChild(link);

            link.addEventListener("click", async () => {
              const response = await fetch(
                `https://clickable-api.clearforme.com/api/app/ingredients/definition/v2?clientname=dime%20beauty&productIngredientId=${ingredient.productIngredientId}&cfmIngredientId=${ingredient.cfmIngredientId}`,
                {
                  method: "GET",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2MzBjYmZiZGJkZmJlOTAwMjFmOTU4MmMiLCJzdG9yZVVybCI6Imh0dHBzOi8vZGltZWJlYXV0eWNvLmNvbS9jb2xsZWN0aW9ucy8iLCJpYXQiOjE2ODQzNTE0MjB9.iCNSO-jE_h7hKuVSADV-l5zBFP6JlrbsdsDTDEsSmUg`,
                  },
                }
              );
              const data = await response.json();

              const cardBody = collapseContainer.querySelector(
                ".ingredient-details"
              );
              const attributeString = data.functions
                .map((item) => item.attribute)
                .join(" | ");

              const additionalDetailsHtml = (attributeString) ? `<p>*Additional Details</p><p>${attributeString}</p>` : "";

              cardBody.innerHTML = `
          <span class="ingredient-name text-capitalize">${data.ingredientName}</span>
          <p class="score-bold">EWG Score: ${data.customNote}</p>
          <p>Definition: ${data.definition}</p>
          ${additionalDetailsHtml}`;
            });
          });
        });
      });
  });
});
